import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import updateSearchQueryStringOperation from 'store/search/operation/updateSearchQueryStringOperation';
import getSearchKeywords from 'store/search/selector/getSearchKeywords';
import { setSearchPageNrAction, setSearchRefetchFlagAction, toggleSearchFilterAction } from 'store/search/slice';
import { SearchKeyword } from 'store/search/types';

const Keywords = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const activeKeywords = useSelector(getSearchKeywords);

  const removeKeyword = (keyword: SearchKeyword) => {
    dispatch(
      toggleSearchFilterAction({
        id: keyword.filterId,
        value: keyword.value,
      }),
    );
    dispatch(setSearchPageNrAction(1));
    dispatch(setSearchRefetchFlagAction(true));
    dispatch(updateSearchQueryStringOperation(history));
  };

  return (
    <>
      {activeKeywords.map((keyword) => (
        <OpButton
          // TODO: fix this
          // key={`kw${keyword.searchId}${keyword.value}`}
          key={`kw${keyword.value}`}
          icon-right="close"
          size="small"
          variant="secondary"
          onClick={() => removeKeyword(keyword)}
        >
          {keyword.keyword}
        </OpButton>
      ))}
    </>
  );
};

export default Keywords;
